const Cart = {
  init() {
    this.removeItem();
    this.productQuantityToggle();
    this.removeCoupon();
    this.hasCheckedTerms();
  },
  removeItem() {
    $(document).on("click", '[data-bb-toggle="remove-from-cart"]', (e) => {
      e.preventDefault();

      const currentTarget = $(e.currentTarget);

      currentTarget.addClass("btn-loading");

      $.ajax({
        url: currentTarget.prop("href") || currentTarget.data("url"),
        method: "GET",
        success: ({ error, message, data }) => {
          if (error) {
            EcommerceApp.showError(message);
          } else {
            EcommerceApp.showSuccess(message);

            currentTarget.closest("tr").remove();

            if (data.count !== undefined) {
              $('[data-bb-value="cart-count"]').text(data.count);

              if (data.count === 0) {
                window.location.reload();
              }
            }

            document.dispatchEvent(
              new CustomEvent("ecommerce.cart.removed", {
                detail: {
                  data,
                  element: currentTarget,
                  extraData: data.extra_data,
                },
              }),
            );
          }
        },
        error: (error) => EcommerceApp.handleError(error),
        complete: () => currentTarget.removeClass("btn-loading"),
      });
    });
  },
  productQuantityToggle() {
    $(document).off("click.cartQuantity", '[data-bb-toggle="product-quantity-toggle-cart"]');
    $(document).on("click.cartQuantity", '[data-bb-toggle="product-quantity-toggle-cart"]', function (e) {
      e.preventDefault();
      const $currentTarget = $(e.currentTarget);

      let $calculation = $currentTarget.data("value");

      if (!$calculation) {
        return;
      }

      let $input = null;

      if ($calculation === "plus") {
        $input = $currentTarget.prev();
      } else if ($calculation === "minus") {
        $input = $currentTarget.next();
      }

      if (!$input) {
        return;
      }

      let $quantity = parseInt($input.val()) || 1;

      $input.val($calculation === "plus" ? $quantity + 1 : $quantity === 1 ? 1 : $quantity - 1);

      document.dispatchEvent(
        new CustomEvent("ecommerce.cart.quantity.change", {
          detail: {
            element: $currentTarget,
            action: $calculation === "plus" ? "increase" : "decrease",
          },
        }),
      );
    });
  },
  handleUpdateCart(element) {
    let form;

    if (element) {
      form = $(element).closest("form");
    } else {
      form = $("form.cart-form");
    }

    const payload = form.serialize();

    const request = $.ajax({
      type: "POST",
      url: form.prop("action"),
      data: payload,
      success: ({ error, message, data }) => {
        if (error) {
          EcommerceApp.showError(message);

          if (data) {
            this.ajaxLoadCart(data);
          }

          return;
        }

        this.ajaxLoadCart(data);
      },
      error: (error, status) => {
        if (status !== "abort") {
          EcommerceApp.handleError(error);
        }
      },
      complete: () => {
        if (form.data("quantityRequest") === request) {
          form.removeData("quantityRequest");
        }
      },
    });

    form.data("quantityRequest", request);
  },
  scheduleUpdateCart(element) {
    const form = element ? $(element).closest("form") : $("form.cart-form");
    const pendingTimer = form.data("quantityTimer");
    const pendingRequest = form.data("quantityRequest");

    if (pendingTimer) {
      clearTimeout(pendingTimer);
    }

    if (pendingRequest) {
      pendingRequest.abort();
      form.removeData("quantityRequest");
    }

    form.data(
      "quantityTimer",
      setTimeout(() => {
        form.removeData("quantityTimer");
        this.handleUpdateCart(element);
      }, 400),
    );
  },
  ajaxLoadCart(data) {
    if (!data) {
      return;
    }

    const $cart = $('[data-bb-toggle="cart-content"]');

    if (data.count !== undefined) {
      $('[data-bb-value="cart-count"]').text(data.count);
    }

    if (data.total_price !== undefined) {
      $('[data-bb-value="cart-total-price"]').text(data.total_price);
    }

    if ($cart.length) {
      $cart.replaceWith(data.cart_content);
      this.productQuantityToggle();

      $.ajax({
        url: window.siteUrl + "/ajax/cart",
        method: "GET",
        success: (response) => {
          if (!response.error) {
            $(".ps-cart--mobile").html(response.data.html);
            $(".btn-shopping-cart span i").text(response.data.count);

            if (typeof Theme.lazyLoadInstance !== "undefined") {
              Theme.lazyLoadInstance.update();
            }
          }
        },
        error: (res) => {
          Theme.showError(res.message);
        },
      });
    }
  },
  removeCoupon() {
    $(document).on("click", `[data-bb-toggle="remove-coupon"]`, (event) => {
      event.preventDefault();

      $("#coupon-remove-form").submit();
    });
  },
  hasCheckedTerms() {
    $(document).on("click", '[data-bb-toggle="cart-checkout"]', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const isChecked = $('[data-bb-toggle="cart-terms"]').is(":checked");

      if (!isChecked) {
        EcommerceApp.showError("Please agree to the terms and conditions before proceeding to checkout.");
        return;
      }

      const checkoutUrl = e.currentTarget.getAttribute("href");
      window.location.href = checkoutUrl;
    });
  },
  handleUpdateCartContent() {
    const wrapper = $(".js-cart-content-wrapper");

    if (wrapper.length) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      $("#quick-shop-modal").modal("hide");
      $(".cart-card").addClass("card-loading");
      wrapper.load(window.location.href + " .js-cart-content-wrapper > *", function () {
        Cart.productQuantityToggle();
        $(".cart-card").removeClass("card-loading");
      });
    }
  },
};

$(function () {
  Cart.init();

  document.addEventListener("ecommerce.cart.quantity.change", (e) => {
    const { element } = e.detail;
    Cart.scheduleUpdateCart(element);
  });
});
